import { mutateAdmin, queryAdmin } from '../graphql-client.js';

const EXPORT_PROJECT_MUTATION = /* GraphQL */ `
  mutation {
    id: exportProject(origin: "@takeshape/client")
  }
`;

const GET_PROJECT_EXPORT_QUERY = /* GraphQL */ `
  query ($exportId: String!) {
    export: getProjectExport(id: $exportId) {
      id
      status
      file
    }
  }
`;

export const exportProject = mutateAdmin(EXPORT_PROJECT_MUTATION);
export const getProjectExport = queryAdmin(GET_PROJECT_EXPORT_QUERY);
